module.exports = __webpack_public_path__ + "static/media/isha_khutafale.b65fb1e6.png";